import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';
import { Stack } from '@mui/system';

import WaveUIForm_V2 from '@/shared/components/forms/WaveUIForm_V2';
import FieldType from '@/shared/components/forms/WaveUIForm_V2/types/fieldType.enum';
import WaveUIAccordion from '@/shared/components/widgets/WaveUIAccordion';

type RemoveInventoryItemsWidgetProps = {
  inventoryItemsTotal: number;
  onRemoveInventoryItems: (value: number) => void;
};

const RemoveInventoryItemsWidget: FC<RemoveInventoryItemsWidgetProps> = ({
  inventoryItemsTotal,
  onRemoveInventoryItems,
}) => {
  const { t } = useTranslation(['inventory', 'common']);

  const [form, setForm] = useState({
    qty: 0,
  });

  return (
    <WaveUIAccordion
      title={t('inventory:removeInventoryItems')}
      defaultExpanded
    >
      <WaveUIForm_V2
        fields={[
          {
            field_type: FieldType.Number,
            field_props: {
              name: 'qty',
              label: t('inventory:quantity'),
              value: form.qty.toString(),
              placeholder: t('inventory:numberOfAtomsToRemove'),
              required: true,
            },
          },
        ]}
        getFieldsValues={(value) => {
          setForm((prev) => ({ ...prev, ...value }));
        }}
      />

      <Stack sx={{ alignItems: 'flex-end' }}>
        <Button
          variant='contained'
          color='error'
          disabled={
            form.qty === 0 ||
            form.qty > inventoryItemsTotal ||
            inventoryItemsTotal === 0
          }
          onClick={() => onRemoveInventoryItems(form.qty)}
        >
          {t('inventory:removeInventory')}
        </Button>
      </Stack>
    </WaveUIAccordion>
  );
};

export default RemoveInventoryItemsWidget;
